import { SideBarOptionMenu } from '@/types/sidebar'
import { MdOutlineAcUnit } from 'react-icons/md'

export const unitMenu: SideBarOptionMenu = {
  name: 'Purchase unit',
  icon: MdOutlineAcUnit,
  path: '/unit',
  order: 1,
  permission: { name: 'settings', can: 'visible' },
  isShown: true,
  isActive: false,
  child: [],
}
